import { useContext } from 'react'

import {
  AdminViewContext,
  type AdminViewContextType,
} from '../contexts/AdminViewContext'

/**
 * Hook to access admin view state and controls.
 * Must be used within AdminViewProvider.
 */
export const useAdminView = (): AdminViewContextType => {
  const context = useContext(AdminViewContext)
  if (context === undefined) {
    throw new Error('useAdminView must be used within an AdminViewProvider')
  }
  return context
}
